import CancelablePromise from "mn-utils/CancelablePromise";
import {apiAppGet, apiAppNotificationHeaderList} from "../../../../../../../../api/merchant/app";

module.exports = (params) => CancelablePromise.all([
  apiAppGet(params),
  apiAppNotificationHeaderList({
    app_id: params.id,
  }),
]).then(([
 response,
 headerList,
]) => {
  const notificationSettings = response.notification_settings || {};
  notificationSettings.headers = headerList.headers;
  response.notification_settings = notificationSettings;
  return response;
});
